const categories = {
  Home: 'danger',
  Work: 'info',
  Personal: 'success'
}

export default categories
